import React from 'react'

const SkeletonDashboard = () => {
    return (
        <div className='skl-dashboard'>
            <div className="row">
                {
                    Array.from({ length: 6 }).fill('1').map((_, ind) => {
                        return (
                            <div className="col-lg-2 col-md-4 col-sm-6 col-6" key={ind}>
                                <div className='skl-column-1 skl'></div>
                            </div>
                        )
                    })
                }
            </div>
            <div className="row">
                {
                    Array.from({ length: 4 }).fill('1').map((_, ind) => {
                        return (
                            <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12" key={ind}>
                                <div className='skl-column-2 skl'></div>
                            </div>
                        )
                    })
                }
            </div>
            <div className="row">
                {
                    Array.from({ length: 6 }).fill('1').map((_, ind) => {
                        return (
                            <div className="col-lg-2 col-md-4 col-sm-6 col-6" key={ind}>
                                <div className='skl-column-1 skl'></div>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
}

export default SkeletonDashboard